/**
 * Convertit les balises HTML inline observées en pratique vers markdown.
 * Couverture minimaliste validée : <strong>, <em>, <br>.
 *
 * Règles NOMMÉES (jamais catch-all) — préserve les comparaisons math (<3, a<b).
 * Tag inconnu (ex: <custom>) laissé intact (conservative).
 *
 * Ordre : strong puis em (non-overlap, documenté).
 */
const STRONG_RE = /<strong>([\s\S]*?)<\/strong>/g;
const EM_RE     = /<em>([\s\S]*?)<\/em>/g;
const BR_RE     = /<br\s*\/?\s*>/g;

export function htmlInlineToMarkdown(prose: string): string {
  if (!prose) return prose;
  return prose
    .replace(STRONG_RE, (_, inner) => `**${inner}**`)
    .replace(EM_RE, (_, inner) => `*${inner}*`)
    .replace(BR_RE, '\n');
}
